// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

const useGeneral = () => {
  // Hook
  const {
    general: { general_isOnline, general_isReconnected, general_SET_ONLINE },
  } = useStores()

  /**
   * @description Open new browser tab
   *
   * @param {string} url
   *
   * @return {void} void
   */
  const general_openNewTab = useCallback((url: string): void => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }, [])

  return {
    general_isOnline,
    general_isReconnected,
    general_SET_ONLINE,
    general_openNewTab,
  }
}

export { useGeneral }
